import { GET_USER_PROFILE } from '../constants/ApiConstants';

export const ACTIVE_PROFILE_STORAGE_KEY = 'ga_active_profile';

export const getRoleAccountContactId = (role = {}) => {
  return (
    role.accountContactId ||
    role.account_contact_id ||
    role.accountContact?.id ||
    ''
  );
};

export const getRoleSalesForceId = (role = {}) => {
  return role.salesForceId || role.sales_force_id || '';
};

export const getProfileIdForRole = (role = {}) => {
  const salesForceId = getRoleSalesForceId(role);
  return salesForceId ? `${role.type}:${salesForceId}` : `${role.type}`;
};

export const matchesProfileRef = (profile, ref) => {
  if (!profile || !ref) return false;
  return (
    profile.accountType === ref.type &&
    (profile.salesForceId || null) === (ref.salesForceId || null)
  );
};

// Each role carries the name of the contact linked to that account, so cards
// show the right person per account. Internal roles (admin, sales rep) and the
// legacy email-based flow have no contact, so they fall back to the resolved
// profile's own name.
export const mapRoleToProfile = (role, index, userProfileResponse) => ({
  id: getProfileIdForRole(role),
  firstName: role.contactFirstName || userProfileResponse.first_name || '',
  lastName: role.contactLastName || userProfileResponse.last_name || '',
  accountContactId: getRoleAccountContactId(role),
  accountId: role.accountId || '',
  fsapId: role.fsapId || '',
  salesForceId: getRoleSalesForceId(role),
  toolAdmin: role.toolAdmin || false,
  accountName: role.accountName || '',
  accountType: role.type,
  billingAddress: role.address || '',
});

export const getSelectedUserProfileUrl = ({
  email,
  currUserType,
  seedAdvisorID,
  zdPartnershipUuid,
  salesForceId,
}) => {
  return GET_USER_PROFILE(
    email,
    currUserType,
    seedAdvisorID,
    zdPartnershipUuid,
    salesForceId
  );
};

export const readActiveProfile = () => {
  try {
    const raw = window.localStorage.getItem(ACTIVE_PROFILE_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    console.warn('Failed to read active profile from localStorage:', e);
    return null;
  }
};

export const writeActiveProfile = (profileId, authTime) => {
  try {
    window.localStorage.setItem(
      ACTIVE_PROFILE_STORAGE_KEY,
      JSON.stringify({ profileId, authTime })
    );
  } catch (e) {
    console.warn('Failed to write active profile to localStorage:', e);
  }
};

export const clearActiveProfile = () => {
  try {
    window.localStorage.removeItem(ACTIVE_PROFILE_STORAGE_KEY);
  } catch (e) {
    console.warn('Failed to clear active profile from localStorage:', e);
  }
};

export const getOktaAuthTime = async (oktaAuth) => {
  try {
    const idToken = await oktaAuth.tokenManager.get('idToken');
    return idToken?.claims?.auth_time;
  } catch (e) {
    console.warn('Failed to read auth_time from Okta id token:', e);
    return undefined;
  }
};
